Service = App.loadClass 'core::Angular/Service'
Handler = App.loadClass 'core::Handler'
DeleteDialog = App.loadClass 'core::DeleteDialog'

class exports.LegacyHandlerService extends Service
    constructor: (@rootScope, @timeout, @legend) ->

        # Variable Declarations
        @singleSubHandler = false
        @activeSubHandlers = {}
        @currentDialog = ''
        @saveUrl = ''

    getLegacyFilePath: (layerType) =>

        switch layerType
            when 'nitrogen'
                @currentDialog = 'grower::handlers/data/layers/Layer_Nitrogen_Dialog'
                @saveUrl = 'backend/grower/layers/nitrogen/update'
            when 'ears_rows_length'
                @currentDialog = 'grower::handlers/data/layers/Layer_Ears_Rows_Length_Dialog'
                @saveUrl = 'backend/grower/layers/ears-rows-length/update'
            when 'harvest_load'
                @currentDialog = 'grower::handlers/data/layers/Layer_Harvest_Load_Dialog'
                @saveUrl = 'backend/grower/layers/harvest-load/update'
            when 'prescription_map'
                @currentDialog = 'grower::handlers/data/layers/Layer_Prescription_Map_Dialog'
                @saveUrl = 'backend/grower/layers/prescription-map/update'
            when 'stand_count'
                @currentDialog = 'grower::handlers/data/layers/Layer_Stand_Count_Dialog'
                @saveUrl = 'backend/grower/layers/standcount/update'
            when 'planting_rx'
                @currentDialog = 'grower::handlers/data/layers/Layer_Planting_Rx_Visualize'
                @saveUrl = ''
            when 'soils'
                @currentDialog = 'grower::handlers/data/layers/Layer_Soil'
                @saveUrl = ''
            when 'management_zone'
                @currentDialog = 'grower::handlers/data/layers/Layer_Management_Zones'
            when 'cdl'
                @currentDialog = 'grower::handlers/data/layers/Layer_CDL'
                @saveUrl = ''
            when 'pad'
                @currentDialog = 'grower::handlers/data/layers/Layer_PAD'
                @saveUrl = ''
            when 'shapefile'
                @currentDialog = 'grower::handlers/data/layers/shapefile/Layer_Shapefile'
                @saveUrl = ''
            when 'ShapefileBinning'
                @currentDialog = 'grower::handlers/data/layers/shapefile/Layer_Shapefile_Binning'
                @saveUrl = 'backend/grower/layers/shapefile/set-binning'

    createViewDialog: (layerName, saveUrl = null, is_new, is_editable, row = null, postOps) =>
        row.rowClass = 'darken' unless row is null

        newLayerName = layerName + postOps.layer_id

        if is_new
            view = @createSubHandler(layerName)
        else
            view = @createSubHandler(layerName, newLayerName)
        if view

            view.loadLayoutPostOptions = {

                fields_id: postOps.fields_id
                has_edit: postOps.has_edit
                id: postOps.id
                layer_id: postOps.layer_id
                year: postOps.year
                extra_data: postOps.extra_data
            }

            view.startEditing = (is_new or is_editable)

            view.refreshNavHandler = false

            if saveUrl is null
                view.saveUrl = @saveUrl
            else
                view.saveUrl = saveUrl
            view.afterHidden = () =>
                if view.refreshing
                    view.refreshing = false
                    return

                view.destroy()
                @rootScope.$broadcast('legacyDialog:closed', { layer: row })


            view.successAction = () =>

                #TODO: This needs finished. The sidebar content is refreshing but
                # if the field name is changed it's not being updated
                changeFieldDetails = 'grower::handlers/fields/dialogs/FieldDetailsDialog'

                # We need to refresh the sidebar if planting layers
                # have been converted or field details has changed
                if @currentDialog is changeFieldDetails
                    @rootScope.$broadcast('layer:updated', { layer: null })

            # removed temporarily for https://www.pivotaltracker.com/story/show/177318692
            # handle creating and maintaining legends for rx maps
            # if layerName is 'planting_rx'
            #     @legend.geojsonLayerHandlerProcessingRedirect(view, layerName, postOps.layer_id)

            view.init()

            return view

    addLayer: (layerType, postOps) ->
        switch(layerType)
            when 'Nitrogen'
                @currentDialog = 'grower::handlers/data/layers/Layer_Nitrogen_Dialog'
                @createViewDialog('Nitrogen', 'backend/grower/layers/nitrogen/add', true, true, null, postOps)
            when 'Stand Count'
                @currentDialog = 'grower::handlers/data/layers/Layer_Stand_Count_Dialog'
                @createViewDialog('StandCount', 'backend/grower/layers/standcount/add', true, true, null, postOps)
            when 'Ears, Rows, and Length'
                @currentDialog = 'grower::handlers/data/layers/Layer_Ears_Rows_Length_Dialog'
                @createViewDialog(
                    'EarsRowsLength',
                    'backend/grower/layers/ears-rows-length/add',
                    true,
                    true,
                    null,
                    postOps
                )
            when 'Harvest Load'
                @currentDialog = 'grower::handlers/data/layers/Layer_Harvest_Load_Dialog'
                @createViewDialog('HarvestLoad', 'backend/grower/layers/harvest-load/add', true, true, null, postOps)
            when 'Prescription Map'
                @currentDialog = 'grower::handlers/data/layers/Layer_Prescription_Map_Dialog'
                @createViewDialog('PlantingRx', 'backend/grower/layers/planting-rx/sidebar', true, true, null, postOps)

    getDeletePath: (layer_type) ->
        switch (layer_type)
            when 'planting'
                @saveUrl = 'backend/grower/layers/planting/delete'
            when 'nitrogen'
                @saveUrl = 'backend/grower/layers/nitrogen/delete'
            when 'fertilizer'
                @saveUrl = 'backend/grower/layers/fertilizer/delete'
            when 'spraying'
                @saveUrl = 'backend/grower/layers/spraying/delete'
            when 'stand_count'
                @saveUrl = 'backend/grower/layers/standcount/delete'
            when 'ears_rows_length'
                @saveUrl = 'backend/grower/layers/ears-rows-length/delete'
            when 'harvest_load'
                @saveUrl = 'backend/grower/layers/harvest-load/delete'
            when 'prescription_map'
                @saveUrl = 'backend/grower/layers/prescription-map/delete'
            when 'shapefile'
                @saveUrl = 'backend/grower/layers/shapefile/delete'
            when 'planting_rx'
                @saveUrl = 'backend/grower/layers/planting-rx/delete'
            when 'management_zone'
                @saveUrl = 'backend/grower/layers/management-zones/delete'
            when 'cover_crop'
                @saveUrl = 'backend/grower/layers/cover-crop/delete'

    createDeleteDialog: (layer) =>
        ths = this
        @getDeletePath(layer.layer_type)
        ## attach our own data to the generic Delete_Dialog class ###
        # @getLegacyFilePath(layer.orig_title)
        del = @createSubHandler DeleteDialog
        if del
            del.deleteTitle = '- ' + layer.orig_title + ' Layer'
            del.deleteMessage = 'this ' + layer.orig_title  + ' Layer'
            del.deleteItemID = layer.id
            del.saveUrl = @saveUrl
            del.delayAfterSuccess = true
            del.refreshNavHandler = false
            del.successAction = () =>
                ths.rootScope.$broadcast('layer:updated', { layer: layer })

            del.init()

    createSubHandler: (sub, name = null) =>
        # we shouldn't be having children if we're dead!
        if @__destroyed then return null
        handler = (@subHandlers?[sub]?.class) ? sub
        name    = name ? handler

        # Handle destroying current handler (if we have
        # singleSubHandler set to true). If we already have
        # a subhandler with the name we want exists

        if @singleSubHandler
            for i, v of @activeSubHandlers
                v.destroy()
        else if @activeSubHandlers[name]?
            return false

        # If the handler we detected is a string, we'll
        # assume it's a path for a module to be required.
        # If it's not, we'll assume that it's a class that
        # we can instantiate

        if typeof handler is 'string'
            object = window.App.loadClass(@currentDialog)
        else
            object = handler

        # Instantiate the handler, and assign it.
        handlerObj = new object()
        handlerObj.nameInParent = name
        handlerObj.parent = this

        @activeSubHandlers[name] = handlerObj

        # If we have any other attributes in the subHandlers definition
        # for the requested subhandler, then assign them.
        # if @subHandlers?[sub]?.attrs
        #     for k, v of @subHandlers[sub].attrs
        #         @scope.activeSubHandlers[name][k] = v
        return @activeSubHandlers[name]

     destroySubHandler: (name, calldestroy = false) =>
         if @subHandlers?[name]?
             name = @subHandlers[name].class

         if @activeSubHandlers?[name]?
             if calldestroy
                 @activeSubHandlers[name].destroy()
             else
                 @activeSubHandlers[name] = null
                 delete @activeSubHandlers[name]

    destroyAllSubHandlers: (toDestroy = null) =>
        if toDestroy?
            # Destroy everything passed in
            for layer in toDestroy
                for k, v of @activeSubHandlers
                    if layer is k
                        @destroySubHandler k, true
        else
            # Destroy everything
            for k, v of @activeSubHandlers
                @destroySubHandler k, true
